import { useNavigate } from 'react-router-dom';
import Modal from '@/components/Modal/Modal';
import Button, { ButtonSizes, ButtonVariants } from '@/components/new-design/Button';
import { TableState } from '@/services/table/tableState';

const DuplicateTableModal = ({ table, onClose }: { table: TableState; onClose: () => void }) => {
  const navigate = useNavigate();

  const handleClose = () => {
    onClose();
    navigate('/');
  };

  return (
    <Modal open setClose={handleClose} className="text-white lg:min-w-[500px]">
      <div className="flex flex-col items-center justify-center gap-6 text-center">
        <p className="text-xl">You already have an instance of this table:</p>
        <p className="text-xl font-bold">{table.name}</p>
        <div className="flex w-full items-stretch justify-center">
          <Button
            className="rounded-full px-8 text-sm font-bold"
            onClick={handleClose}
            size={ButtonSizes.xl}
            variant={ButtonVariants.transparentWithBorder}
          >
            OK
          </Button>
        </div>
      </div>
    </Modal>
  );
};

export default DuplicateTableModal;
